import { Pipe, PipeTransform } from '@angular/core'
import {
  ExperimentalPrice,
  LANG_DEFAULT,
  PriceObject,
  PriceObjectWithDiscount,
} from '@naturalcycles/shared'
import { getSignalStore } from '@src/app/core/store/signalStore.js'

@Pipe({
  name: 'price',
  standalone: true,
})
export class PricePipe implements PipeTransform {
  transform(
    priceObject?: PriceObject | PriceObjectWithDiscount,
    opts: PricePipeOptions = {},
  ): string {
    if (!priceObject) return ''

    let price = ExperimentalPrice.fromObject(priceObject)
    const withDiscount = opts.withDiscount ?? true
    if ('discountPercentage' in priceObject && withDiscount) {
      price = price.withDiscount(priceObject.discountPercentage)
    }

    return price.toLocaleString(getSignalStore().$lang() || LANG_DEFAULT)
  }
}

interface PricePipeOptions {
  /**
   * Determines whether we include the discount in the price
   * If false, the pipe will ignore the discount percentage and show the gross amount
   * @default true
   */
  withDiscount?: boolean
}
